import {IPlannerPropertyRoomExposureSide} from "../../types/planner_property/IPlannerPropertyRoomExposureSide";

export const getPlannerPropertyWorldSideName = (side: IPlannerPropertyRoomExposureSide) => {
    switch (side) {
        case "N":
            return "północ";
        case "NE":
            return "północny-wschód";
        case "NW":
            return "północny-zachód";
        case "E":
            return "wschód";
        case "W":
            return "zachód";
        case "S":
            return "południe";
        case "SE":
            return "południowy-wschód";
        case "SW":
            return "południowy-zachód";
        default:
            return "";
    }
};
import {IPlannerPropertyRoomExposureSide} from "../../types/planner_property/IPlannerPropertyRoomExposureSide";

export const getPlannerPropertyWorldSideName = (side: IPlannerPropertyRoomExposureSide) => {
    switch (side) {
        case "N":
            return "północ";
        case "NE":
            return "północny-wschód";
        case "NW":
            return "północny-zachód";
        case "E":
            return "wschód";
        case "W":
            return "zachód";
        case "S":
            return "południe";
        case "SE":
            return "południowy-wschód";
        case "SW":
            return "południowy-zachód";
        default:
            return "";
    }
};
